import React from "react";
import Dropzone from "react-dropzone";
import { DnDContext, DnDStore } from "./DnDContext";

type Props = {
  children: React.ReactElement<any>;
};

const DnDRoot: React.FC<Props> = (props) => {
  const dndStore = new DnDStore();

  return (
    <Dropzone onDrop={dndStore.acceptDroppedFiles} accept={dndStore.config.acceptTypes}>
      {(dzProps) => (
        <DnDContext.Provider
          value={{
            accept: dndStore.config.acceptTypes,
            dzProps,
            acceptDroppedFiles: dndStore.acceptDroppedFiles,
            listen: dndStore.listen,
            listener: dndStore.listener
          }}
        >
          {props.children}
        </DnDContext.Provider>
      )}
    </Dropzone>
  );
};

export default DnDRoot;
